import { typedApi } from "@/api/typed-client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import type { JobOut } from "./queries";

export interface CancelJobResponse {
  job_id: string;
  final_status: string;
}

export function useCancelJob() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string): Promise<CancelJobResponse> => {
      const { data, error } = await typedApi.POST("/v1/jobs/{job_id}/cancel", {
        params: { path: { job_id: id } },
      });
      if (error) throw new Error(JSON.stringify(error));
      // The API returns a JobOut; map to our CancelJobResponse shape
      const job = data as JobOut;
      return { job_id: job.id, final_status: job.status };
    },
    onSuccess: (res, id) => {
      qc.invalidateQueries({ queryKey: ["jobs"] });
      qc.invalidateQueries({ queryKey: ["jobs", id] });
      toast.success(`Job ${res.final_status}`);
    },
    onError: (e) => toast.error(`Cancel failed: ${(e as Error).message}`),
  });
}
